import Link from "next/link";
import { RightOutlined } from "@ant-design/icons";
import { Card } from "antd";
import UserAvatar from "components/user/UserAvatar";
import moment from "moment";
import { userUrl } from "utils/route";
import { useSelector } from "react-redux";

const CityOwnerCard = ({ city }: any) => {
  const user = useSelector((state: any) => state.user.user);

  return (
    <Card title="创建者">
      <Link
        legacyBehavior
        href="/users/[id]"
        as={userUrl(city.owner, user)}
      >
        <a target="_blank">
          <div className="owner-card">
            <div className="left">
              <UserAvatar
                user={city.owner}
                size={48}
              />
              <div>
                <div className="nickname">{city.owner.nickname}</div>
                <div className="create-time">
                  {moment(city.created_at).format("YYYY.MM.DD")}创建
                </div>
              </div>
            </div>
            <RightOutlined style={{ color: "#9b9b9b" }} />
          </div>
        </a>
      </Link>
    </Card>
  );
};

export default CityOwnerCard;
